import { Component } from '@angular/core';

@Component({
  selector: 'co-loader',
  template: '',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {}
